<template>
  <UDashboardGroup unit="rem">
    <UDashboardSidebar
      collapsible
      :min-size="15"
      :default-size="15"
      :max-size="15"
      :ui="{
        root: 'group',
        header: [
          'group-data-[collapsed=true]:px-3',
          'group-data-[collapsed=true]:justify-center',
        ],
      }"
    >
      <template #header="{ collapsed }">
        <AppHeaderLogo :collapsed="collapsed" />
      </template>
      <template #default="{ collapsed }">
        <UNavigationMenu
          :collapsed="collapsed"
          :items="menuLists"
          orientation="vertical"
          tooltip
          popover
          :ui="{
            link: collapsed ? 'justify-center' : '',
          }"
        >
          <template #item-trailing="{ item }">
            <UBadge
              v-if="item.badge !== undefined"
              class="rounded-full"
              variant="solid"
            >
              {{ item.badge }}
            </UBadge>
          </template>
        </UNavigationMenu>

        <AppNavigationManual
          v-if="isCompanyUser || isTeamUser"
          :collapsed="collapsed"
          :checklist="onboardChecklist"
        />
      </template>
    </UDashboardSidebar>

    <UDashboardPanel>
      <template #header>
        <UDashboardNavbar :ui="{ right: 'gap-3' }">
          <template #title>
            <UBreadcrumb
              v-if="breadcrumbs.length > 0"
              :items="breadcrumbs"
              class="hidden sm:flex"
            />
          </template>
          <template #leading>
            <UDashboardSidebarCollapse />
          </template>

          <template #right>
            <UButton
              variant="outline"
              color="primary"
              label="ไปหน้าหลัก Report"
              :to="{ name: 'dashboard-slug' }"
            />
            <AppMenuUserDropdown></AppMenuUserDropdown>
          </template>
        </UDashboardNavbar>
      </template>

      <template #body>
        <slot />

        <div id="teleport-slideover"></div>
      </template>
      <template #footer>
        <div
          id="teleport-dashboard-footer"
          class="w-full"
        ></div>
      </template>
    </UDashboardPanel>

    <CustomModalAdminOrganizationTutotrialOrganizationAskingUser
      v-if="showAskingModal"
      @close="handleAskingModalClose"
    />
  </UDashboardGroup>
</template>

<script setup lang="ts">
const authStore = useAuthStore();
const { isCompanyUser, isTeamUser, isSuperUser, onboardChecklist } = storeToRefs(authStore);

const route = useRoute();

const breadcrumbs = computed<any[]>(() => {
  return route?.meta?.breadcrumbs || [];
});

const menuLists = computed(() => MENU_LISTS);

const showAskingModal = ref(false);
const { initializeTutorial, startTutorial } = useDriverTutorial();

const checkShowAskingModal = () => {
  if (isSuperUser.value) return;
  const routeName = route.name?.toString();
  if (routeName.startsWith("admin-organization-company")) {
    showAskingModal.value = false;
    return;
  }
  if (onboardChecklist.value?.manage_organization === false) {
    showAskingModal.value = true;
  }
};

const handleAskingModalClose = (confirmed: boolean) => {
  showAskingModal.value = false;

  if (confirmed) {
    initializeTutorial(tutorialFlowsCompany.companyPage);
    startTutorial();
  }
};

onMounted(async () => {
  showAskingModal.value = false;
  await authStore.refreshOnboardChecklist();
  await authStore.refreshPreConfig();
  checkShowAskingModal();
});

watch(
  () => onboardChecklist.value,
  () => {
    checkShowAskingModal();
  },
  { deep: true },
);
</script>

<style scoped></style>
